import React, { Suspense } from 'react';
import Layout from '../components/Layout';
import HeroSection from '../components/HeroSection';
import LogosSection from '../components/LogosSection';
import ContactSection from '../components/ContactSection';
import { 
  ServicesSection,
  ReferencesSection,
  TestimonialsSection
} from '../utils/lazyComponents';
import LoadingSpinner from '../components/LoadingSpinner';

const HomePage: React.FC = () => {
  return (
    <Layout
      title="Stimm.DEV | App-Entwicklung & digitale Lösungen aus Berlin"
      description="Stimm.DEV - Professionelle App-Entwicklung für iOS, Android und Web. Maßgeschneiderte digitale Lösungen für KMUs mit Expertise in Flutter, Swift und ReactJS."
      keywords="App-Entwicklung, Flutter, Mobile Apps, Webentwicklung, Berlin, KMU, Software-Agentur"
      includeReviewSchema={true}
    >
      <section className="wrapper">
        <HeroSection />

        <LogosSection />

        <Suspense fallback={<LoadingSpinner />}>
          <ServicesSection />
        </Suspense>

        <Suspense fallback={<LoadingSpinner />}>
          <ReferencesSection />
        </Suspense>

        <Suspense fallback={<LoadingSpinner />}>
          <TestimonialsSection />
        </Suspense>

        <ContactSection />
      </section>
    </Layout>
  );
};

export default HomePage;
